<template>
    <div id="pricingSocials" class="space-y-5">
        <p class="ct-text">
            {{ $t("faq.layout.socials_info") }}
        </p>
        <div class="space-y-3">
            <SocialCard
                v-for="social in socials"
                :key="social.title"
                :social="social"
                @click="$emit('edit', social)"
                @edit="$emit('edit', social)"
            />
        </div>
    </div>
</template>

<script>
import { markRaw } from "vue";
import { mapState } from "vuex";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";

import {
    FacebookIcon,
    TwitterIcon,
    YoutubeIcon,
    LinkedinIcon,
    InstagramIcon,
    GithubIcon,
    DribbleIcon,
    GlobeIcon,
    TikTokIcon,
} from "@easy/ui/icons";
import SocialCard from "./SocialCard.vue";

export default {
    components: {
        SocialCard,
    },
    setup() {
        useFocusOnQueryField();
    },
    emits: ["edit"],
    computed: {
        ...mapState("pricing", ["pricing"]),
        socials() {
            return [
                {
                    predefined: true,
                    title: "WWW",
                    icon: markRaw(GlobeIcon),
                    url: this.pricing.socials.wwwUrl,
                    changeUrl: (url) => {
                        this.pricing.socials.wwwUrl = url;
                    },
                },
                {
                    predefined: true,
                    title: "Facebook",
                    icon: markRaw(FacebookIcon),
                    url: this.pricing.socials.fbUrl,
                    changeUrl: (url) => {
                        this.pricing.socials.fbUrl = url;
                    },
                },
                {
                    predefined: true,
                    title: "X (Twitter)",
                    icon: markRaw(TwitterIcon),
                    url: this.pricing.socials.twitterUrl,
                    changeUrl: (url) => {
                        this.pricing.socials.twitterUrl = url;
                    },
                },
                {
                    predefined: true,
                    title: "Youtube",
                    icon: markRaw(YoutubeIcon),
                    url: this.pricing.socials.youtubeUrl,
                    changeUrl: (url) => {
                        this.pricing.socials.youtubeUrl = url;
                    },
                },
                {
                    predefined: true,
                    title: "Linkedin",
                    icon: markRaw(LinkedinIcon),
                    url: this.pricing.socials.linkedinUrl,
                    changeUrl: (url) => {
                        this.pricing.socials.linkedinUrl = url;
                    },
                },
                {
                    predefined: true,
                    title: "Instagram",
                    icon: markRaw(InstagramIcon),
                    url: this.pricing.socials.igUrl,
                    changeUrl: (url) => {
                        this.pricing.socials.igUrl = url;
                    },
                },
                {
                    predefined: true,
                    title: "GitHub",
                    icon: markRaw(GithubIcon),
                    url: this.pricing.socials.ghUrl,
                    changeUrl: (url) => {
                        this.pricing.socials.ghUrl = url;
                    },
                },
                {
                    predefined: true,
                    title: "Dribble",
                    icon: markRaw(DribbleIcon),
                    url: this.pricing.socials.dribbleUrl,
                    changeUrl: (url) => {
                        this.pricing.socials.dribbleUrl = url;
                    },
                },
                {
                    predefined: true,
                    title: "TikTok",
                    icon: markRaw(TikTokIcon),
                    url: this.pricing.socials.tiktokUrl,
                    changeUrl: (url) => {
                        this.pricing.socials.tiktokUrl = url;
                    },
                },
            ];
        },
    },
};
</script>
